<template>
  <base-slide-over ref="slideOver" title="New Training" size="lg">
    <inline-error id="save-training-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    <base-form ref="form" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid">
      <base-text-field label="Name" placeholder="Enter a name for the training" v-model="name" class="tw-mt-3" required :readonly="isLoading" :maxLength="255" />
      <base-textarea label="Description" placeholder="Enter description" :rows="4" v-model="description" :readonly="isLoading" required />
      <div class="tw-grid tw-grid-cols-3 tw-gap-4">
        <base-text-field
          class="tw-col-span-2"
          label="Category"
          placeholder="Enter a category for the training"
          v-model="category"
          required
          :readonly="isLoading"
          :maxLength="255"
        />
        <base-text-field label="Sort Order" v-model="sortOrder" :readonly="isLoading" :maxLength="255" />
      </div>
      <FormulateForm name="fileInputForm">
        <FormulateInput
          type="file"
          name="file"
          label="Select your training document to upload"
          help="Word (.docx), Powerpoint (.pptx), PDF, PNG, JPG, MP4, M4V"
          validation="required|mime:application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,image/jpeg,image/png,video/mp4,video/x-m4v"
          v-model="document"
        />
      </FormulateForm>
      <FormulateForm name="imageInputForm" class="tw-mt-4">
        <FormulateInput type="file" name="file" label="Select your cover image to upload" help="PNG, JPG" validation="required|mime:image/jpeg,image/png" v-model="imageFile" />
      </FormulateForm>
    </base-form>
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" @click="hide()" class="tw-mr-3">Cancel</base-button>
        <base-button @click="saveTraining()" :disabled="!isFormValid" :loading="isLoading">Save</base-button>
      </div>
    </template>
  </base-slide-over>
</template>
<script>
import InlineError from "@/components/InlineError";

export default {
  name: "NewTraining",
  components: {
    InlineError,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isFormValid: true,
      isLoading: false,
      name: null,
      category: null,
      description: null,
      sortOrder: null,
      document: null,
      imageFile: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    saveTraining() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;

      let documentId = null;
      if (this.document) documentId = this.document.files[0].path.documentId;

      let imageDocumentId = null;
      if (this.imageFile) imageDocumentId = this.imageFile.files[0].path.documentId;

      this.$axios
        .post(`/businesses/${this.businessId}/trainings`, {
          documentId: documentId,
          imageDocumentId: imageDocumentId,
          name: this.name,
          category: this.category,
          description: this.description,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.$emit("saved");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Training Saved", message: `Training ${this.name} was created successfully.` });
          this.reset();
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Failed to save ${this.name}`;
          this.errorMessage = `Training ${this.name} was not able to be created. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reset() {
      this.name = null;
      this.description = null;
      this.sortOrder = null;
      this.category = null;
      this.document = null;
      this.imageFile = null;
    },
    show() {
      this.$refs.slideOver.show();
      this.reset();
    },
    hide() {
      this.$refs.slideOver.hide();
      this.reset();
    },
  },
};
</script>
